import React from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import "react-bootstrap-table/dist/react-bootstrap-table-all.min.css";
import { Card, CardBody } from "reactstrap";

const options = {
  sortIndicator: true,
  paginationSize: 3,
  clearSearch: true,
  alwaysShowAllBtns: true,
  withFirstAndLast: true,
  hideSizePerPage: false,
  hidePageListOnlyOnePage: false,
};

export default function DayBookBody({ data }) {
  const commonThStyle = {
    whiteSpace: "nowrap", // Prevent wrapping
    fontWeight: "600", // Slightly bold for better readability
    textAlign: "center", // Center-align text
    fontSize: "13px", // Standardized font size for headers
    backgroundColor: "#f8f9fa", // Light gray background for better contrast
    color: "#495057", // Dark gray text for better readability
    borderBottom: "2px solid #dee2e6", // Add a bottom border for separation
  };

  const commonTdStyle = {
    whiteSpace: "normal", // Allow wrapping for data cells
    fontSize: "12px", // Slightly smaller font size for data
    color: "#212529", // Standard text color
  };

  return (
    <div>
      <Card>
        <CardBody>
          <BootstrapTable
            data={data}
            version="4"
            condensed
            striped
            hover
            pagination
            search
            options={options}
            exportCSV
            csvFileName="day_book.csv"
          >
            <TableHeaderColumn isKey dataField="id" hidden>
              ID
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="name"
              csvHeader="Name"
              filter={{ type: "TextFilter", delay: 1000 }}
              dataSort
              tdStyle={commonTdStyle}
              thStyle={commonThStyle}
            >
              Name
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="type"
              csvHeader="Type"
              filter={{ type: "TextFilter", delay: 1000 }}
              dataSort
              tdStyle={commonTdStyle}
              thStyle={commonThStyle}
            >
              Type
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="moneyIn"
              csvHeader="Money In"
              filter={{ type: "TextFilter", delay: 1000 }}
              dataSort
              tdStyle={commonTdStyle}
              thStyle={commonThStyle}
            >
              Money In
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="moneyOut"
              csvHeader="Money Out"
              filter={{ type: "TextFilter", delay: 1000 }}
              dataSort
              tdStyle={commonTdStyle}
              thStyle={commonThStyle}
            >
              Money Out
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="bankName"
              csvHeader="Bank Name"
              filter={{ type: "TextFilter", delay: 1000 }}
              dataSort
              tdStyle={commonTdStyle}
              thStyle={commonThStyle}
              editable
            >
              Bank Name
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="runningBalance"
              csvHeader="Running Balance"
              filter={{ type: "TextFilter", delay: 1000 }}
              dataSort
              tdStyle={commonTdStyle}
              thStyle={commonThStyle}
            >
              Running Balance
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="referenceNumber"
              csvHeader="Reference No."
              filter={{ type: "TextFilter", delay: 1000 }}
              dataSort
              tdStyle={commonTdStyle}
              thStyle={commonThStyle}
            >
              Reference No.
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="paymentOrExpenseDate"
              csvHeader="Entry Date"
              filter={{ type: "TextFilter", delay: 1000 }}
              dataSort
              tdStyle={commonTdStyle}
              thStyle={commonThStyle}
              dataFormat={(cell) => {
                return new Date(cell).toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                });
              }}
            >
              Entry Date
            </TableHeaderColumn>
          </BootstrapTable>
        </CardBody>
      </Card>
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/components/CustomComponents/DayBookBody.js